export const createMenuRepository = (appFetch) => {
    return {
        get(options) {
            return appFetch.get('/menu.json', options);
        },
    };
};
